import React from 'react';
import PropTypes from 'prop-types';
import Html from '../Layout/Html';

const Accordion = ({ title, content, ...props }) => {
  return (
    <details {...props}>
      <summary>{title}</summary>
      <Html dangerouslySetInnerHTML={{ __html: content }} />
    </details>
  );
};

Accordion.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
};

export default Accordion;
